import useDarkMode from '@/hooks/useDarkMode'
import { motion } from 'framer-motion'

export const InfoSection = ({
  title,
  subtitle,
  body,
  imageSrc,
  reverse = false,
  comingSoon = false,
}: {
  title: string
  subtitle?: string
  body: React.ReactNode
  imageSrc: string
  reverse?: boolean
  comingSoon?: boolean
}) => {
  const isDark = useDarkMode()

  return (
    <section className="w-full px-4 sm:px-6 md:px-12 lg:px-36 py-16">
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.3 }}
        transition={{ duration: 0.6, ease: 'easeOut' }}
        className={`flex flex-col-reverse ${
          reverse ? 'md:flex-row-reverse' : 'md:flex-row'
        } gap-10 items-center`}
      >
        <motion.div
          initial={{ opacity: 0, x: reverse ? 40 : -40 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.6, ease: 'easeOut', delay: 0.1 }}
          className="w-full md:w-1/2 text-center md:text-left"
        >
          <h2 className="text-3xl md:text-4xl font-bold mb-4">{title}</h2>
          {subtitle && <p className="text-xl text-gray-500 mb-4">{subtitle}</p>}
          <div className="text-md text-gray-700 dark:text-gray-300">{body}</div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, x: reverse ? -40 : 40 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.6, ease: 'easeOut', delay: 0.2 }}
          className="w-full md:w-1/2 flex items-center justify-center min-h-[200px]"
        >
          {comingSoon ? (
            <div className="text-center border border-dashed border-gray-400 dark:border-gray-600 p-10 rounded-lg text-gray-500 dark:text-gray-400 italic text-lg shadow-inner">
              🚧 Coming Soon 🚧
            </div>
          ) : (
            <img
              src={`${imageSrc}-${isDark ? 'dark' : 'light'}.png`}
              alt={title}
              className="w-full h-full mx-auto rounded-lg shadow-md dark:border p-1"
            />
          )}
        </motion.div>
      </motion.div>
    </section>
  )
}
